import 'whatwg-fetch';
import Promise from 'promise-polyfill';

import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import {
    Router, Route, Switch, Redirect
} from 'react-router-dom';
import history from './history';
import Variables from "./Utils/Variables";
import Api from "./Utils/Api";
import Registry from "./Utils/Registry";
import Helpers from "./Utils/Helpers";

import {TokenHandler} from "./auth";
import { notify } from "./Utils/Observers";
import { USER_LOGGED_IN_EVENT } from "./Utils/Events";
import { AddFCScript } from "./Utils/Freshchat";

// Styles
// Import Main styles for this application
import '../scss/style.scss';
import 'react-tippy/dist/tippy.css';
import "font-awesome/css/font-awesome.css";

// Containers
import Full from './containers/Full';
import ResetPass from "./pages/ResetPass";
import Creation from "./pages/Creation";
import {NotificationContainer, NotificationManager} from "react-notifications";

import moment from "moment";

import { 
    AuthInit,
    IsLogged, 
    SignOut, InitiateLogin, GetAuthorizationHeader
} from "@TaankYou/auth";
import { api as serviceApi } from "@TaankYou/services";

// To add to window
if (!window.Promise) 
    window.Promise = Promise;


function twoDigits(d) {
    if(0 <= d && d < 10) return "0" + d.toString();
    if(-10 < d && d < 0) return "-0" + (-1*d).toString();
    return d.toString();
}

Date.prototype.toMysqlFormat = function(withHours=true) {
    let parts = [
        `${this.getUTCFullYear()}-${twoDigits(1 + this.getUTCMonth())}-${twoDigits(this.getUTCDate())}`,
        `${twoDigits(this.getUTCHours())}:${twoDigits(this.getUTCMinutes())}:${twoDigits(this.getUTCSeconds())}`
    ];

    if(withHours)
        return parts.join(" ");
    return parts[0];
};

AuthInit(Variables.auth);

const api = new Api(Variables.api);
Registry.register("api", api);

let stripe = Stripe(Variables.stripe_token);
Registry.register("stripe", stripe);

const noAuthPages = [
    "creation-compte",
    "oauth",
    "mot-de-passe-oublie",
    "handle_token"
];

const AuthRoute = (props) => {
    if(IsLogged())
        return <Route {...props} />;
    else 
        InitiateLogin();
    return null;
}

//history.listen(checkLogin);

moment.locale('fr', {
    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
    monthsParseExact : true,
    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Aujourd’hui à] LT',
        nextDay : '[Demain à] LT',
        nextWeek : 'dddd [à] LT',
        lastDay : '[Hier à] LT',
        lastWeek : 'dddd [dernier à] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dans %s',
        past : 'il y a %s',
        s : 'quelques secondes',
        m : 'une minute',
        mm : '%d minutes',
        h : 'une heure',
        hh : '%d heures',
        d : 'un jour',
        dd : '%d jours',
        M : 'un mois',
        MM : '%d mois',
        y : 'un an',
        yy : '%d ans'
    },
    dayOfMonthOrdinalParse : /\d{1,2}(er|e)/,
    ordinal : function (number) {
        return number + (number === 1 ? 'er' : 'e');
    },
    meridiemParse : /PD|MD/,
    isPM : function (input) {
        return input.charAt(0) === 'M';
    },

    meridiem : function (hours, minutes, isLower) {
        return hours < 12 ? 'PD' : 'MD';
    },
    week : {
        dow : 1,
        doy : 4
    }
});

const App = () => {

    AddFCScript(Variables.freshchatToken)
    api.getUser()

    return <div>
        <Router history={history}>
            <Switch>
                <Redirect from="/" exact to="/home" />
                
                <Route path="/handle_token" exact component={() => <TokenHandler 
                        onSuccess={user => {
                            if(!user.business_id){
                                NotificationManager.error("Votre compte n'est pas un compte professionnel");
                                const { protocol, host } = window.location;
                                SignOut(`${protocol}//${host}`);
                            }
                            else{
                                let lastLocation = api.webStorage.getItem("last-location");
                                api.webStorage.removeItem("last-location");
                                Helpers.goTo(lastLocation ? lastLocation : "/home", true);
                            }
                        }}
                    />} 
                />
                
                <Route path="/creation-compte/:token" name="Creation du compte" component={Creation} />
                <Route path="/mot-de-passe-oublie" exact name="Reset du mot de passe" component={ResetPass} />
                <Route path="/mot-de-passe-oublie/:token" exact name="Reset du mot de passe" component={ResetPass} />

                <AuthRoute path="/" name="Home" component={Full} />
            </Switch>
        </Router>

        <NotificationContainer/>
    </div>
};


ReactDOM.render(<App />, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js